import { useState } from 'react';
import CollapsedCard from './CollpasedCard';
import { UnknownCard } from './DeckWithHover';
const { Modal } = require('react-bootstrap');
const CardConverter = require('@tta/engine/Utilities/Converters/CardConverter');
const Leaders = require('@tta/engine/Constants/Leaders/Leaders');
const Wonders = require('@tta/engine/Constants/Wonders/Wonders');

// How the game's leaders and wonders were chosen, and what the players know of them (see the engine's
// Constants/CardVersions.js)
const PickText = {
    all: 'Picked at random from both the base game and the expansion.',
    new: 'All of the expansion\'s, with one base-game leader and one base-game wonder per age picked at random.',
    custom: 'Picked at random from a custom set.',
};
const RevealText = {
    public: 'Everyone knows them from the start.',
    byAge: 'Each age\'s are revealed as it begins.',
    secret: 'No one knows them until they are drawn.',
};
const Description = (pool) => pool.cards === 'mix' ? `${PickText[pool.pick] ?? PickText.all} ${RevealText[pool.reveal] ?? ''}`
    : pool.cards === 'base' ? 'The base game\'s leaders and wonders.'
    : pool.cards === 'expansion' ? 'Only the expansion\'s leaders and wonders.'
    : 'Every leader and wonder of the base game and the expansion.';

// An age's leaders, then its wonders: those known (faded once drawn, in an age everyone knows), then a placeholder for
// each one not known yet
const AgeCards = ({age, cards, unknown}) => {
    const hidden = unknown && (unknown.leaders || unknown.wonders);
    return ['Leader', 'Wonder'].map(type => {
        const known = cards.filter(({ card }) => card.type === type);
        const missing = unknown?.[type === 'Leader' ? 'leaders' : 'wonders'] ?? 0;
        return <div key={type} className="tta-deck-list-cards tta-pool-row">
            {known.map(({ card, remaining }) =>
                <div key={card.name} style={{ opacity: remaining || hidden ? 1 : 0.4 }} title={remaining || hidden ? undefined : 'Already drawn'}>
                    <CollapsedCard card={card}/>
                </div>)}
            {Array.from({ length: missing }, (_, index) =>
                <UnknownCard key={index} card={{ of: type, age, name: `Unknown ${type.toLowerCase()}`, id: index }}/>)}
        </div>;
    });
};

// The leaders and wonders a custom set left out, by age
function Excluded({names, OnClose})
{
    const ages = ['Age A', 'Age I', 'Age II', 'Age III'];
    const card = (name) => CardConverter({ type: Leaders[name] ? 'Leader' : 'Wonder', name, age: (Leaders[name] ?? Wonders[name]).age, id: -1 });
    return <Modal show onHide={OnClose} centered dialogClassName="tta-deck-list-dialog" backdropClassName="tta-stacked-backdrop" className="tta-stacked-modal">
        <Modal.Header closeButton>
            <Modal.Title>Left out of this game</Modal.Title>
        </Modal.Header>
        <Modal.Body className="tta tta-left">
            {ages.filter(age => names.some(name => (Leaders[name] ?? Wonders[name])?.age === age)).map(age =>
                <div key={age} className="tta-deck-list-section">
                    <div className="tta-deck-list-title">{age}</div>
                    <div className="tta-deck-list-cards">
                        {names.filter(name => (Leaders[name] ?? Wonders[name])?.age === age).map(name => <CollapsedCard key={name} card={card(name)}/>)}
                    </div>
                </div>)}
        </Modal.Body>
    </Modal>;
}

// The game's leaders and wonders (see GameViewModel.leadersAndWonders): a button in the game's title bar that opens how
// they were chosen and, age by age, those the viewer knows of
function LeadersAndWonders({Pool})
{
    const [show, setShow] = useState(false);
    const [showExcluded, setShowExcluded] = useState(false);
    if (!Pool)
    {
        return null;
    }
    return <>
        <button type="button" className="tta-title-button" onClick={() => setShow(true)}>Leaders &amp; wonders</button>
        <Modal show={show} onHide={() => setShow(false)} centered size="lg" dialogClassName="tta-deck-list-dialog">
            <Modal.Header closeButton>
                <Modal.Title>Leaders and wonders</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tta tta-left">
                <div className="tta-muted" style={{ marginBottom: '10px' }}>
                    {Description(Pool)}
                    {Pool.excluded.length > 0 && <> <button type="button" className="tta-link-button" onClick={() => setShowExcluded(true)}>
                        {Pool.excluded.length} left out</button></>}
                </div>
                {Pool.ages.map(({ age, cards, unknown }) =>
                    <div key={age} className="tta-deck-list-section">
                        <div className="tta-deck-list-title">{age}</div>
                        {unknown === null ? <div className="tta-muted">Not known yet</div> : <AgeCards age={age} cards={cards} unknown={unknown}/>}
                    </div>)}
            </Modal.Body>
        </Modal>
        {showExcluded && <Excluded names={Pool.excluded} OnClose={() => setShowExcluded(false)}/>}
    </>;
}

export default LeadersAndWonders;
